"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const config_1 = __importDefault(require("next/config"));
const { serverRuntimeConfig = {} } = (0, config_1.default)();
const { crossLoginHostWhitelist = '' } = serverRuntimeConfig;
function serverValidateCrossLoginUrl(url) {
    const hostWhitelist = crossLoginHostWhitelist
        .split(',')
        .map((x) => x.trim());
    const urlObject = new URL(url);
    return hostWhitelist.includes(urlObject.hostname);
}
exports.default = serverValidateCrossLoginUrl;
//# sourceMappingURL=serverValidateCrossLoginUrl.js.map